import PortalMUI from '@mui/material/Portal';

type PortalProps = React.ComponentProps<typeof PortalMUI>;

const Portal = ({ children, ...props }: Readonly<PortalProps>) => {
  return <PortalMUI {...props}>{children}</PortalMUI>;
};

export default Portal;
